import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj19 = () => {
  return (
    <Layout>
      <SEO title="Guess the movie name" description="Awesome python project" />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-19">
          <div className="py-1-heading">
            <h1>Guess the movie name</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/Guess%20The%20Movie%20Name"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              Almost everyone surely played this game !<br />
              <br />
              It is a two player game.
              <br />
              We have a bunch of movies in a list from both players.
              <br />
              Player will get a movie name completely hidden.
              <br />
              He have to guess the movie by letter or later he can say the
              complete name at once also.
              <br />
              <br />
              Players will get score, as they guess correct name.
              <br />
              Game will quit only one of the player wants.
              <br />
              <br />
              Let's guess it !!!...
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Random</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj19
